import { InputProps, InputRef, RefSelectProps } from 'antd'
import clsx from 'shared/libs/clsx'
import { useClickOutside } from 'shared/libs/hooks/useClickOutside/useClickOutside'

import {
  Dispatch,
  KeyboardEvent,
  MouseEvent,
  ReactNode,
  RefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from 'react'

import './CustomInput.css'

type Props = InputProps & {
  children: ReactNode
  childrenRef: RefObject<InputRef | RefSelectProps>
  wrapperClassname?: string
  placeholderClassname?: string
  open?: () => void
  setIsFocus: Dispatch<SetStateAction<boolean>>
  isFocus: boolean
}

const CustomInput = ({
  placeholder,
  children,
  value,
  childrenRef,
  placeholderClassname,
  open,
  wrapperClassname,
  isFocus,
  setIsFocus,
}: Props) => {
  const wrapperRef = useRef<HTMLButtonElement>(null)

  const [minWrapperHeight, setMinWrapperHeight] = useState<number>(0)

  const handleClickWrapper = (event: MouseEvent | KeyboardEvent) => {
    event.preventDefault()
    if (wrapperRef.current?.contains(event.target as Node)) {
      if (open) open()
      else childrenRef.current?.focus()
      setIsFocus(true)
    }
  }

  useClickOutside(wrapperRef, () => {
    setIsFocus(false)
  })

  useEffect(() => {
    const labelHeight = 16
    const paddingYWrapper = 12
    const inputHeight = childrenRef.current?.nativeElement?.offsetHeight
    if (inputHeight) {
      setMinWrapperHeight(labelHeight + paddingYWrapper + inputHeight)
    }
  }, [childrenRef])

  return (
    <button
      type="button"
      className={`customInput relative flex items-end w-full px-[16px] py-[6px]
         rounded-[16px] border-[1.5px] border-light_gray_10 cursor-text ${wrapperClassname}`}
      onClick={handleClickWrapper}
      ref={wrapperRef}
      style={{ minHeight: minWrapperHeight }}
    >
      <label
        className={clsx(
          `z-[2] absolute left-[16px] top-[50%] translate-y-[-50%] text-light_gray_11 text-[16px] leading-[24px]
           pointer-events-none select-none transition-all duration-[0.2s] ease-in-out`,
          {
            [`!top-[14px] !text-[12px] leading-[16px] ${placeholderClassname}`]:
              isFocus || value,
          },
        )}
      >
        {placeholder}
      </label>
      {children}
    </button>
  )
}

export default CustomInput
